import * as signalR from '@microsoft/signalr';

let signalRConnection: signalR.HubConnection;
let initialized = false;

export default {
  init() {
    // Prevent duplicate connect calls on re-init.
    if (initialized) {
      return;
    }

    signalRConnection = new signalR.HubConnectionBuilder()
      .withUrl(process.env.VUE_APP_HUB_ROOT + '/streamhub')
      .withAutomaticReconnect([0, 2000, 5000, 10000, 30000])
      .build();

    initialized = true;
    signalRConnection
      .start()
      .catch((e: any) =>
        console.error('[StreamingHub] initial connect failed:', e)
      );
  },
  stop() {
    initialized = false;
    if (signalRConnection) {
      signalRConnection.stop();
    }
  },
  getConnection() {
    return signalRConnection;
  },
};
